import { useTranslation } from 'react-i18next';
import { DayOfWeek, getWeekStartByLocale } from 'weekstart';

export function useStartOfWeek(): DayOfWeek {
  const { i18n } = useTranslation();
  return getWeekStartByLocale(i18n.language);
}
